module.exports = __webpack_public_path__ + "static/img/ydyl3.af3e5df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/ydyl3.jpg
// module id = pSdA
// module chunks = 0